import React from 'react';

const ButtonPrimary = ({ color, onClick, children, size = 'medium', disabled = false, label }) => {
  const sizeClasses = size === 'large' ? 'px-6 py-3 text-lg' : 'px-4 py-2 text-sm';
  const disabledClasses = disabled ? 'opacity-50 cursor-not-allowed' : '';

  return (
    <button
      onClick={onClick}
      className={`bg-blue-800 hover:bg-blue-900 font-bold text-white rounded ${sizeClasses} ${color} ${disabledClasses}`}
      disabled={disabled}
    >
      {label || children}
    </button>
  );
};

export default ButtonPrimary;
